// src/components/Navbar/Navbar.js

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assests/logo.jpeg";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  /* CLOSE MENU + TOP */
  const closeMenu = () => {
    setMenuOpen(false);

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  /* HOME CLICK */
  const goHome = () => {
    navigate("/");

    setMenuOpen(false);

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <header className="navbar">

      {/* MOBILE LEFT */}
      <button
        className="hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? "✕" : "☰"}
      </button>

      {/* CENTER TITLE */}
      <div
        className="brand-name clickable-brand"
        onClick={goHome}
      >
        <h1>Rootly Homoeopathy</h1>
        <span>Healing From The Root Up</span>
      </div>

      {/* RIGHT LOGO */}
      <div
        className="logo-wrap clickable-brand"
        onClick={goHome}
      >
        <img
          src={logo}
          alt="Rootly Homoeopathy"
          className="nav-logo"
        />
      </div>

      {/* DESKTOP NAV */}
      <nav className="desktop-nav">

        <Link to="/" onClick={closeMenu}>
          Home
        </Link>

        <Link to="/about" onClick={closeMenu}>
          About
        </Link>

        <Link to="/services" onClick={closeMenu}>
          Services
        </Link>

        <Link to="/appointment" onClick={closeMenu}>
          Appointment
        </Link>

      </nav>

      {/* MOBILE MENU */}
      <div className={menuOpen ? "mobile-menu show" : "mobile-menu"}>

        <Link to="/" onClick={closeMenu}>
          Home
        </Link>

        <Link to="/about" onClick={closeMenu}>
          About
        </Link>

        <Link to="/services" onClick={closeMenu}>
          Services
        </Link>

        <Link to="/appointment" onClick={closeMenu}>
          Appointment
        </Link>

      </div>

    </header>
  );
}

export default Navbar;